var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.artwork)?_c('div',{staticClass:"col-12 row auctions__row no-gutters",attrs:{"id":("artwork_" + (_vm.artwork.id))}},[_c('ArtworkCatalogNumber',{staticClass:"col-sm-1",attrs:{"catalogNumber":_vm.artwork.catalogNumber}}),_vm._v(" "),_c('ArtworkDetails',{attrs:{"artwork":_vm.artwork,"index":_vm.index}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-169e22c5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/auctions_catalogs/show/components/artwork/row.vue
// module id = 795
// module chunks = 0 1 2 3 4 5 6 7 8 10 18 87